import { render, staticRenderFns } from "./VContractDetailNoteForm.vue?vue&type=template&id=1979c6bf&"
import script from "./VContractDetailNoteForm.vue?vue&type=script&lang=js&"
export * from "./VContractDetailNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports